import type { TranslocoConfig } from '@jsverse/transloco';

import { environment } from '../environments/environment';

// TODO: Move file one directory up to src if you agree that you would look for
// it there.
export const translocoConfig: Partial<TranslocoConfig> = {
  availableLangs: ['en', 'de'],
  defaultLang: 'en',
  fallbackLang: 'en',
  // Remove this option if your application doesn't support changing language in runtime.
  reRenderOnLangChange: true,
  prodMode: environment.production,
};
